import actionCreatorFactory from 'typescript-fsa'
import { Account } from '../../api/account/types'
import { APIError } from '../../api/types'

const actionCreator = actionCreatorFactory('@@uplive/account')

export const getAccountActions = actionCreator.async<void, Account, APIError>('getAccount')

export const signOut = actionCreator('signOut')
